import { memo as Memo, useCallback, useState } from 'react';

//* HOC's
import withUIContext from '@context/consumerHOC/UIConsumer';

//* Components
import TableItem from '@components/global/TableItem';
import PageTopSection from '@components/global/PageTopSection';
import AboutAnimChars from '@components/global/SvgComponents/AboutAnimChars';

//* Styles
import OurValuesStyle from './style';

const OurValues = Memo(({ active, items, isMobile, ...props }) => {
	//! States
	const [activeAnim, setActiveAnim] = useState();

	const onMouseEnter = useCallback((index) => {
		setActiveAnim(index);
	}, []);

	const onMouseLeave = useCallback(() => {
		setActiveAnim(null);
	}, []);

	return (
		<OurValuesStyle>
			<PageTopSection {...props} />

			<div className={`articleWrap`}>
				{items.map((item, ind) => {
					return (
						<div
							key={ind}
							className='article-item'
							onMouseLeave={onMouseLeave}
							onMouseEnter={() => onMouseEnter(ind)}>
							<TableItem
								count
								active={active}
								minWidth
								underline={false}
								title={item.title}
								titleStyle={'titleStyle'}
								description={item.description}
								animationDelay={0.6 + 0.2 * ind}
								animation={
									((!isMobile && activeAnim === ind) || isMobile) && (
										<AboutAnimChars
											type={ind + 1}
											play
										/>
									)
								}
							/>
						</div>
					);
				})}
			</div>
		</OurValuesStyle>
	);
});

export default withUIContext(OurValues, ['isMobile']);
